﻿/* 
Object:         Navigation Bar (this is only active in the mobile view)
Description:    Events related towards navigation (nodes and modules) 
                Ensures that the session is up to date on the selected node en the selected module.
                It also makes sure that the module is loaded in the module area.
Used in:        Whole web application (navigation / loading module / start module / breadcrumb)
*/

/*---[ ESLint ]---*/
/*
    global translatedLabels 
*/


window.navigation = function () {

    var selected_node_id = -1;                                  // Current selected nodeid
    var selected_menu_id = -1;                                  // Current selected menuid
    var selected_module_has_childeren = false;                  // Indicates if the user clicked on a group of modules

    var expand_initial_treeview_nodeid = new Array();           // Expand towards a particulair node in the nodetree after loading
    var first_load_page = true;                                 // boolean first event call to onDatabound for the nodetree
    var selection_node = false;                                 // Select node only once when everyhting is loaded

    var expand_initial_modulemenu = false;                      // initial expand module menu
    var nodetree_expanded_counter = 1;                          // Expanding counter (counts until the list is finished, then selection node with event handler select)
    var is_mobile = false;                                      // Used to for example decide to collapse the modulemenu and nodetree when something is clicked. It will show the start module
                                                                // When a module is clicked, in mobile view the module menu will collapse then to make place for the module view.

    /**
    * Load a part of the nodetree using the parent node.
    * @param {any} parentNodeId
    */
    function loadPartialNodetree(nodeid) {
        if (is_mobile) {
            $.get(appsettings.getUrl("Navigation/GetPartialNodeTree?parentNodeId=" + nodeid), function (data, status) {
                $(".nav-mobile-root").html(data);
            });
        }
    }

    /**
    * Load a part of the nodetree using the parent node.
    * @param {any} parentNodeId
    */
    function setFirstLoadPage(val) {
        selection_node = false;         // node selected
        nodetree_expanded_counter = 1;  // counter
        first_load_page = val;          // fired when page first loaded
    }

    /**
    * Go to a specific node from the nodetree or navigate action from the breadcrumb. Load the startModule of the newly node.
    * @param {any} selected_node_id
    * @param {any} skipModuleRefresh
    * @param {any} skipTreeRefresh
    */
    function selectNodeAndModule(selected_node_id, skipModuleRefresh, skipTreeRefresh) {
        // When selecting a new node. viewmode -> edit
        viewmode.setViewMode(ModuleActionViewEnum.Edit);

        // Update session about it 
        $.getJSON(appsettings.getUrl("Navigation/NavigateToNode?nodeId=" + selected_node_id), function (dataNode) {

            // When navigation is succesfull.
            if (dataNode.Succesfully) {

                // If it's not the breadcrumb. load the node with the specific start module.
                if (!skipModuleRefresh) {
                    // Loading Start Module
                    $.getJSON(appsettings.getUrl("Navigation/NavigateToModule?moduleId=" + dataNode.startModuleId), function (dataModule) {

                        if (dataModule.Succesfully) {
                            // destroy any previouse loaded widget that can cause problems
                            // this is also good to manage the dom.
                            unloadKendoWidgetFromPreviousModule(dataModule.previousModule);

                            // Load new module
                            // Session will be updated.
                            $("#moduleLayout").data('kendoSplitter').ajaxRequest("#ModuleArea", appsettings.getLocalUrl("Module/LoadModule"));

                            // refresh pane mobile ()
                            if (is_mobile) {
                                $("#contentLayout").data('kendoSplitter').ajaxRequest($("#OverviewSelectedNodeAndModule"), appsettings.getLocalUrl("navigation/OverviewSelectedNodeAndModule"));
                            }
                        }

                    });

                    // Loading Module Menu
                    $.get(appsettings.getUrl("Navigation/GetModuleMenu"), function (dataMenu, status) {

                        // initial module menu expand set to false. will load new menu
                        expand_initial_modulemenu = false;

                        // Loading Data in the menu
                        $('#ModuleMenu').html(dataMenu);

                        // refresh pane mobile ()
                        if (is_mobile) {
                            $('#MobileModuleMenu').html(dataMenu);
                        }

                    });                    
                }
                else {
                    /*empty block ?*/
                }

                if (!skipTreeRefresh) {
                    // Set first load page
                    setFirstLoadPage(true);  

                    // Refresh nodeTree (navigate)
                    $("#contentLayout").data('kendoSplitter').ajaxRequest($("#NodeTree"), appsettings.getLocalUrl("Navigation/GetNodeTree"));
                }

                navigation.refreshAccountActionPane();
            }
        });
    }    

    /**
    * Unload any widgets used in the previous module. 
    * This is to ensure that the DOM elements tree will not become to big resulting in a slow/sloppy end-user expierence. 
    * @param {any} previousModule
    */
    function unloadKendoWidgetFromPreviousModule(previousModule) {

        kendo.destroy($("#precom-form-feedback")); // if any (notifications)

        $('[data-role="popup"]').each(function (index, element) {
            kendo.destroy($(element));
            $(element).parent().remove();
        });

        $('[role="dialog"]').each(function (index, element) {
            kendo.destroy($(element));
            $(element).parent().remove();
        });

    }

    /**
    * Change the datasource of the current nodetree. Specify a search word.
    */
    function searchNodes() {
        var search = $("#nodetree-search-value-action").val();

        if (search != undefined && search != null) {

            var searchNodesUrl = appsettings.getLocalUrl("Navigation/SearchNodes?name=" + search);

            if (!is_mobile) {

                // Desktop Search (kendo node tree)
                $("#node-tree-precom").data("kendoTreeView").dataSource.transport.options.read.url = searchNodesUrl; // change
                $("#node-tree-precom").data("kendoTreeView").dataSource.read(); // refresh

            } else {

                // Mobile 
                $.getJSON(searchNodesUrl, function (data) {

                    $.post({
                        type: "POST",
                        url: appsettings.getUrl("Navigation/GetPartialSearchResultNodeTree"),
                        data: {
                            searchResult: data
                        },
                        success: function (responseData) {
                            $(".nav-mobile-root").html(responseData);
                        }
                    });
                });
            }

            $("#nodetree-search-action-cancel").show();
        }
    }

    /**
     * Cancel method to search nodes
     */ 
    function cancelSearchNodes() {

        if (!is_mobile) {
            selection_node = false;         // node selected
            nodetree_expanded_counter = 1;  // counter
            first_load_page = true;         // fired when page first loaded

            $("#contentLayout").data('kendoSplitter').ajaxRequest($("#NodeTree"), appsettings.getLocalUrl("Navigation/GetNodeTree"));
        }

        $("#nodetree-search-action-cancel").hide(); // hide cancel button
        $("#nodetree-search-value-action").val(''); // empty search
        main.setHideDivBootstrap("DivNoResults", false);
    }

    return {

        /**
         * Reset function for loading the nodetree (selection active node)
         * This is only active when the nodetree load initial.
         * You can reset this before reloading the pane.
         * @param {number} homenodeid 
         * @param {number} selectedNodeIdFromSession
         * @param {string} jsonStr
         * @param {boolean} isMobile
         */
        initialize: function (homenodeid, selectedNodeIdFromSession, jsonStr, isMobile) {

            // Set var isMobile 
            is_mobile = isMobile; 

            // Onclick events 
            $("#nodetree-search-action").click(function () {
                searchNodes();
            });


            $("#nodetree-search-action-cancel").click(function () {
                cancelSearchNodes();
            });

            // Hide cancel search
            $("#nodetree-search-action-cancel").hide();

            // Has clicked on a node before (from current session.)
            if (selectedNodeIdFromSession > 0) {
                // Format and set it ready for method: expandPath.
                var arr = new Array();

                // 
                for (var i = 0; i < jsonStr.length; i++) {
                    arr.push(jsonStr[i].NodeId);
                }

                // 
                expand_initial_treeview_nodeid = arr;

                // 
                selected_node_id = selectedNodeIdFromSession;
                
                // Load navtree partial (selected node)
                loadPartialNodetree(selected_node_id);
            }
            else // first time open.
            {
                if ($("#node-tree-precom").data("kendoTreeView") != undefined &&
                    $("#node-tree-precom").data("kendoTreeView").dataSource.data()[0] != undefined) {
                    // No childeren (hide nodetree pane)
                    if (!$("#node-tree-precom").data("kendoTreeView").dataSource.data()[0].hasChildren) {
                        // hide
                        $("#contentLayout").data('kendoSplitter').toggle($("#NodeTree"), false);
                    }
                }

                // Load navtree partial (selected node)
                loadPartialNodetree(homenodeid);                
            }

            navigation.refreshAccountActionPane();
        },

        /**
         * Reset function for loading the nodetree (selection active node)
         * This is only active when the nodetree load initial.
         * You can reset this before reloading the pane.
         * @param {value} val
         */
        setFirstLoadPage: function (val) {
            setFirstLoadPage(val);
        },

        refreshAccountActionPane: function() {
            // Loading AccountActionPane
            $.get(appsettings.getUrl("Account/AccountActionPane"), function (dataMenu, status) {

                // Loading Data in the menu
                $('#AccountActionPane').html(dataMenu);

                // refresh pane mobile ()
                if (is_mobile) {
                    $('#MobileAccountActionPane').html(dataMenu);
                }

            });
        },

        //--- Navigation ----------------------------------------------------------------------------------------------//

        /**
         * Select node by param
        */
        navigateToCurrentNode: function () {

            // 
            $.getJSON(appsettings.getUrl("Navigation/GetSelectedNode"), function (data) {
                if (data.Succesfully) {

                    // selection node
                    selectNodeAndModule(data.NodeId, false, true);

                }
            });

        },

        // This will let you navigate to the current selected module
        navigateToCurrentModule: function () {

            $.getJSON(appsettings.getUrl("Navigation/NavigateToCurrentModule"), function (data) {
                // When successfull (navigation to module).
                // Unload everything from the previouse module (kendo widgets)
                // Load new module in the module pane.
                if (data.Succesfully) {
                    // destroy any previouse loaded widget that can cause problems
                    // this is also good to manage the dom
                    unloadKendoWidgetFromPreviousModule(data.previousModule);

                    // Load new module
                    // Session will be updated.
                    $("#moduleLayout").data('kendoSplitter').ajaxRequest("#ModuleArea", appsettings.getLocalUrl("Module/LoadModule"));
                }
            });
        },

        /**
         * This will let you navigate to the selected module from the breadcrumb (recorded item)
         * @param {boolean} differentModuleId
         */
        navigateToCurrentModuleFromBreadcrumb: function (differentModuleId) {
            $.getJSON(appsettings.getUrl("Navigation/NavigateToCurrentModule"), function (data) {
                // When successfull (navigation to module).
                // Unload everything from the previouse module (kendo widgets)
                // Load new module in the module pane.
                if (data.Succesfully) {
                    // Destroy any previouse loaded widget that can cause problems
                    // this is also good to manage the dom
                    if (differentModuleId) {
                        // 
                        unloadKendoWidgetFromPreviousModule(data.previousModule);
                    }
                    // Load new module
                    // Session will be updated.
                    $("#moduleLayout").data('kendoSplitter').ajaxRequest("#ModuleArea", appsettings.getLocalUrl("Module/LoadModuleFromSession"));
                }
            });
        },

        /**
          * Navigate to a specific url (used in all modules to navigate -> edit)
          * @param {string} url
         */
        navigateToSpecificUrl: function (url) {
            $("#moduleLayout").data('kendoSplitter').ajaxRequest("#ModuleArea", appsettings.getLocalUrl(url));
        },

        /**
        * Jump to a particular node.
        * @param {Number} node_id
        */
        jumpNode: function (node_id) {

            // Set the selected node.
            selectNodeAndModule(node_id, false, false);
        },

        //--- Tree ----------------------------------------------------------------------------------------------//

        /**
         * Databound nodetree
         * @param {event} e
         */
        onDataBound: function (e) {
            // Get treeNode.
            var treeview = $("#node-tree-precom").data("kendoTreeView");

            // Run this only once for a page load. 
            // This to set the node navigation (expand multiple times) and node selection (too load the corresponding module menu en start module).
            if (first_load_page) {

                // set false (do the expanth to path only once!!)
                // Databound will be called more than once.
                first_load_page = false;

                // navigate (this ensures that the onDataBound is called many times...)
                treeview.expandPath(expand_initial_treeview_nodeid);
            }
            else {
                // Counting the number of expanding
                nodetree_expanded_counter++;
            }

            // If the number of expanding correspond to the number of values in the array to expand. Try to select the node.
            if (!selection_node && nodetree_expanded_counter >= expand_initial_treeview_nodeid.length) {
                var selectedNode = treeview.dataSource.get(selected_node_id);

                if (selectedNode !== undefined) {
                    // find element by uid. (unique identifier)
                    var selectedElement = treeview.findByUid(selectedNode.uid);
                    treeview.select(selectedElement); // does not trigger the event select.

                    // selection node
                    selectNodeAndModule(selected_node_id, false, true);

                    // load only once
                    selection_node = true;
                }
            }

            main.setHideDivBootstrap("DivNoResults", treeview.dataSource.view().length < 1);        // show no results message when nothing found
        },

        /**
         * Expand tree only
         * @param {event} e
         */
        expandNodeTree: function () {
            selection_node = true;          // node selected (state set)
            nodetree_expanded_counter = 1;  // counter (reset counter)
            first_load_page = true;         // fired when page first loaded (set to true)
        },
        
        /**
         * Select Node. When selecting a new node. Refresh the module menu on the right-side.
         * @param {event} e
         */
        selectNode: function (e) {

            function yesAction() {

                // Get selected nodeId
                selected_node_id = $(e.node).find('.data-id').val();

                // Selection node
                selectNodeAndModule(selected_node_id, false, true);

                // Remove selection class 
                $("#NodeTree .k-treeview-leaf").removeClass("k-selected");

                // Add css class 
                var a = $(e.node).find(".k-treeview-leaf");

                for (var i = 0; i < a.length; a++) {
                    var b = a[i];
                    var c = $(b);
                    c.addClass("k-selected");
                }
            }

            // Check if any input is dirty
            inputs.checkDirtyInput(e, yesAction);
        },

        /**
        * Refresh the nodetree
        */
        refreshNodeTree: function () {
            $("#contentLayout").data('kendoSplitter').ajaxRequest($("#NodeTree"), appsettings.getLocalUrl("Navigation/GetNodeTree"));
        },
        
        //--- Menu ----------------------------------------------------------------------------------------------//

        /**
        * Select a module. Load the module in the module area on the right side.
        * @param {event} e
        */
        moduleMenuDataBound: function (e) {
            // Load when the initial node is selected! (page loaded)
            if (selection_node) {
                if (!expand_initial_modulemenu) {
                    // Initial submenu selection
                    var submenu_id_selection = $("#initial_submenu_selection").val();

                    // First expand
                    $("#module-menu-precom").data("kendoPanelBar").expand($(".k-link .data-id[value=" + submenu_id_selection + "]").parent());

                    // It has been expanded!
                    expand_initial_modulemenu = true;
                }
                else {
                    // Child selection (can be more than one)
                    var parent_child_id = $("#initial_module_selection").val().split(",");

                    // Loop through the list
                    for (var i = 0; i < parent_child_id.length; i++) {
                        // no empty records.
                        if (parent_child_id[i] !== '') {

                            // Check if the module button exists after the submenu has been expanded.
                            if ($(".k-link .data-id[value=" + parent_child_id[i] + "]").length > 0) {

                                // Selection module
                                $("#module-menu-precom").data("kendoPanelBar").select($(".k-link .data-id[value=" + parent_child_id[i] + "]").parent().parent());

                                // Break out for loop (module selected!)
                                break;
                            }
                        }
                    }
                }
            }
        },

        /**
         * Select a module. Load the module in the module area on the right side.
         * @param {event} e
         */
        selectModule: function (e) {

            function yesAction() {
                // Remove Classes
                $('*').removeClass('k-overlay'); // remove all overlays
                inputs.removeDirtyInput();       // remove dirty input

                // Do not update selected module. It must be a module and not a category / group.
                if (!selected_module_has_childeren) {

                    $.getJSON(appsettings.getUrl("Navigation/NavigateMenu?menuId=" + selected_menu_id), function (data) {
                        // When successfull (navigation to module).
                        // Unload everything from the previouse module (kendo widgets).
                        // Load new module in the module pane.
                        if (data.Succesfully) {

                            // Destroy any previouse loaded widget that can cause problems
                            // This is also good to manage the dom
                            unloadKendoWidgetFromPreviousModule(data.previousModule);

                            // Reset viewmode to overview 
                            viewmode.setViewMode(ModuleActionViewEnum.Overview);

                            // Collapse nodetree and modulemenu when a new module is loaded
                            // Do this when the mobile view is active.
                            if (is_mobile) {
                                var splitter = $("#contentLayout").data('kendoSplitter');
                                splitter.collapse($("#MobileNodeTree"));
                                splitter.collapse($("#MobileModuleMenu"));
                            }

                            // Load new module


                            // Session will be updated.
                            $("#moduleLayout").data('kendoSplitter').ajaxRequest("#ModuleArea", appsettings.getLocalUrl("Module/LoadModule"));

                        }
                    });
                }
            }

            // Get selected module ID
            selected_menu_id = $(e.item).find('.data-id').val();

            // Is the menu item a category/group or a module ?
            selected_module_has_childeren = ($(e.item).find('.data-hasChilderen').val() === 'true');

            // Check if there are any dirty fields.
            inputs.checkDirtyInput(e, yesAction);
        },

        navigateMenu: function (menuId) {
            $.getJSON(appsettings.getUrl("Navigation/NavigateMenu?menuId=" + menuId), function (data) {
                // When successfull (navigation to module).
                // Unload everything from the previouse module (kendo widgets).
                // Load new module in the module pane.
                if (data.Succesfully) {

                    // Destroy any previouse loaded widget that can cause problems
                    // This is also good to manage the dom
                    unloadKendoWidgetFromPreviousModule(data.previousModule);

                    // Reset viewmode to overview 
                    viewmode.setViewMode(ModuleActionViewEnum.Overview);

                    // Collapse nodetree and modulemenu when a new module is loaded
                    // Do this when the mobile view is active.
                    if (is_mobile) {
                        var splitter = $("#contentLayout").data('kendoSplitter');
                        splitter.collapse($("#MobileNodeTree"));
                        splitter.collapse($("#MobileModuleMenu"));
                    }

                    // Load new module


                    // Session will be updated.
                    $("#moduleLayout").data('kendoSplitter').ajaxRequest("#ModuleArea", appsettings.getLocalUrl("Module/LoadModule"));

                }
            });
        },

        //--- Module ----------------------------------------------------------------------------------------------//



        //--- Mobile ----------------------------------------------------------------------------------------------//
                
        /**
         * Navigate to node and load start module of selected node
         * @param {number} nodeId
        */
        mobileSelectNode: function (nodeId) {
            // Select Node and refresh all panes with new data.
            selectNodeAndModule(nodeId, false, true);

            if (is_mobile) {
                var splitter = $("#contentLayout").data('kendoSplitter');
                splitter.collapse($("#MobileNodeTree"));
                splitter.collapse($("#MobileModuleMenu"));
            }

            // Show Module
            $("#contentLayout").data('kendoSplitter').expand($("#ModuleAreaPane"));
            $("#moduleLayout").data('kendoSplitter').expand($("#ModuleArea"));
            // HACK: this is to move the inner panel back to the top of its parent (ModuleAreaPane) panel
            $("#ModuleArea").css("top", "");

            // Show Overview Selected Node and Module
            $("#contentLayout").data('kendoSplitter').expand($("#OverviewSelectedNodeAndModule"));

            // Refresh Tree in background
            loadPartialNodetree(nodeId);

            var searchField = $("#nodetree-search-value-action").data("kendoTextBox");
            searchField.value("");	
        },

        /**
         * This will let you navigate
         * @param {string} nodeId
        */
        mobileNavigateTo: function (nodeId) {
            loadPartialNodetree(nodeId);
        },

        /**
         * This will let you navigate
         * @param {event} e
         */
        moduleLayoutModuleLoaded: function (e) {
            if (e.pane != undefined) {
                if (e.pane.id == "ModuleArea") {
                    if (is_mobile) {
                        // reload with updated information about the selection
                        $("#contentLayout").data('kendoSplitter').ajaxRequest($("#OverviewSelectedNodeAndModule"), appsettings.getLocalUrl("navigation/OverviewSelectedNodeAndModule"));

                        // unhide when hidden ()
                        var splitter = $("#contentLayout").data('kendoSplitter');
                        splitter.expand($("#OverviewSelectedNodeAndModule"));
                        splitter.expand($("#ModuleAreaPane"));

                        $("#moduleLayout").data('kendoSplitter').expand($("#ModuleArea"));
                        // HACK: this is to move the inner panel back to the top of its parent (ModuleAreaPane) panel
                        $("#ModuleArea").css("top", "");

                    } else {

                        // refresh breadcrumb
                        $("#moduleLayout").data('kendoSplitter').ajaxRequest($("#BreadcrumbArea"), appsettings.getLocalUrl("Breadcrumb/Overview"));
                    }

                    // set viewmode for all the input fields displayed in the module.
                    viewmode.setPaneViewMode(e);

                    // initialize inputs onchange event handler.
                    inputs.initialize(translatedLabels.getTitleDialogUnSavedChanges(), translatedLabels.getContentDialogUnSavedChanges());
                }
            }
        },

        //--- Search ----------------------------------------------------------------------------------------------//

        /**
         * Handle search input. Users kan use the enter key for submitting a search on all the nodes.
         * @param {event} e
         */
        handleSearchOnChange: function (e) {

            // Search nodes funtion
            searchNodes();
        }
    }
}();